import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import styled from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { NA_SITES } from '@/constants/membersday';
import { useLang } from '@/i18n';
import gtm from '@/utils/gtm';
import EFPicture from 'elem/compCommon/EFPicture';

import { IProductItem } from '@/components/MembersDay/type';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';

export interface SingleCardProps {
    title?: string;
    data: IProductItem;
    right?: boolean;
    usedPicPc?: string;
    usedPich5?: string;
    discount?: string;
}

const SingleCard: FC<SingleCardProps> = ({ data, right, usedPicPc, usedPich5, discount, title }) => {
    const { locale } = getLocal();
    const { t } = useLang('membersstore');

    return (
        <div className={`${styled.SingleCard} ${right ? 'right' : ''}`}>
            <div className="card_text">
                <div className="title">
                    {NA_SITES.includes(locale) ? 'EcoFlow ' : ''}
                    {data.title}
                </div>
                {data.subtitle1 && <div className="subtitle1">{data.subtitle1}</div>}
                {data.subtitle2 && <div className="subtitle2">{data.subtitle2}</div>}

                <div className="context_price">
                    <div className="price">{data.memberPrice2}</div>
                    <div className="compareat_price">{data.compareAtPrice2}</div>
                </div>

                <div className="tools">
                    <button
                        className={`banner-button-dark banner-button`}
                        onClick={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'bundle_add_to_cart',
                                list_name: title,
                                product_name: data.title,
                                price: data.memberPrice,
                                tag: 'none',
                                quantity: 1,
                                button_name: t('bestseller.button1'),
                            });
                            const { compareAtPrice, memberPrice, inventoryQuantity, title, variantId, productId, imageUrl } = data;
                            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                                {
                                    compareAtPrice: Number(compareAtPrice),
                                    price: Number(memberPrice),
                                    inventoryQuantity,
                                    inventoryPolicy: data?.inventoryPolicy || 'deny',
                                    productTitle: data?.productTitle || title,
                                    skuTitle: data?.skuTitle || title,
                                    variantId,
                                    productId,
                                    img: data?.img || imageUrl,
                                    variantImg: data?.variantImg || imageUrl,
                                    quantity: 1,
                                } as ItfEcoCartItem,
                            ]);
                        }}
                    >
                        {t('bestseller.button1')}
                    </button>
                    <EditorLink
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: data.title,
                            position: 'Member Store',
                        }}
                        className="banner-button-light banner-button"
                        href={data.productUrl}
                        target="_blank"
                    >
                        {t('bestseller.button2')}
                    </EditorLink>
                </div>
            </div>
            <div className="card_img">
                <EFPicture src={usedPicPc || data.imageUrl} srcPad={usedPicPc || data.imageUrl} srcMobile={usedPich5 || data.imageUrl} alt="" />
                {discount && <div className="off">{discount}</div>}
            </div>
        </div>
    );
};

export default SingleCard;
